<template>
    <div class="img-uploader">
        <button type="button" @click="quitar" class="btn-danger btn--text"><i class="fa fa-times"></i></button>
        <img style="cursor: pointer;" @dblclick="verImagen" width="100%" height="200px;" :id="id" :src="srcImage" :alt="alt">
        <center>
            <input class="mb-2" :ref="'file' + id" @change="changeImagen" type="file" :id="'file' + id">
        </center>
        <modal :name="'imageViewer' + id" scrollable resizable adaptive reset width="75%" height="auto">
            <image-viewer :file="value"></image-viewer>
        </modal>
    </div>
</template>

<script>
import ImageViewer from './ImageViewer.vue';
export default {
    components: {
        ImageViewer
    },
    props: {
        alt: {
            type: String,
            required: false,
            default: ''
        },
        id: {
            type: String,
            required: true
        },
        value: {
            required: false
        }
    },
    data: function () {
        return {
            defaultImage: url + '/images/sin-imagen.jpg',
            srcImage: url + '/images/sin-imagen.jpg',
            modelValue: this.value
        };
    },
    methods: {
        verImagen: function () {
            if (this.modelValue != null)
                this.$modal.show('imageViewer' + this.id);
        },
        quitar: function () {
            this.srcImage = this.defaultImage;
            this.modelValue = null;
            this.$emit('input', this.modelValue);
            this.$refs['file' + this.id].value=null;
        },
        changeImagen: function (event) {
            let output = document.getElementById(this.id);
            let file = event.target.files[0];
            this.modelValue = file;
            this.$emit('input', this.modelValue);
            this.srcImage = URL.createObjectURL(file);
            let that = this;
            output.onload = function() {
                URL.revokeObjectURL(that.srcImage);
            }
        }
    },
    watch: {
        value: function(value){
            let output = document.getElementById(this.id);
            if (value != null) {
                this.srcImage = URL.createObjectURL(value);
            }
            else 
                this.srcImage = this.defaultImage;
            let that = this;
            output.onload = function() {
                URL.revokeObjectURL(that.srcImage);
            }
            this.modelValue = value;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/visitas/ImageUploader.vue